import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import titleize from 'titleize'
import get from 'lodash-es/get'

import { showMoreThreshold } from './utils'
import { commaStyleString } from '../../../../../common/utils/formatString'
import SearchLink from '../../../../shared/containers/searchLinkContainer'
import filterParamsConfig from '../../../../../common/constants/filterParamsConfig'

const PanelBody = props => {
  const {
    items,
    isExpandable,
    isExpanded,
    locationParams,
    togglePanel,
    type
  } = props

  const optionListClassNames = classNames(
    'search-facet-single-select-in-panel',
    {
      'is-expanded': isExpanded && isExpandable
    }
  )

  const highestCount = items
    .map(item => {
      return item.count
    })
    .reduce((pre, cur) => {
      return pre > cur ? pre : cur
    }, 0)

  // calculate the width of the category based on the count
  const calcWidthPercentage = count => {
    let percentage = count / highestCount * 100
    return percentage.toFixed(2)
  }

  const renderOption = (item, idx) => {
    let newQuery = Object.assign({}, locationParams)
    newQuery[type] = item.key
    // reset page
    delete newQuery.page

    // grep the last part of the chose category
    let displayName = titleize(item.key)

    if (type === 'category') {
      displayName = titleize(
        displayName
          .split('/') // eslint-disable-next-line
          [displayName.split('/').length - 1].split('-')
          .join(' ')
      )
    }

    const listClassName = classNames({
      // only apply fds-u-is-hidden class when the list is expanded and has more than 10 items
      'fds-u-is-hidden': !isExpanded && idx >= showMoreThreshold[type]
    })

    const linkStyle = {
      minWidth: '50%',
      width: `calc(${calcWidthPercentage(item.count)}% - 30px)`
    }

    return (
      <li key={idx} className={listClassName}>
        <SearchLink
          locationParams={newQuery}
          style={linkStyle}
          onClick={togglePanel}
          rel="nofollow"
        >
          <div className="search-facet-single-select-panel__title">
            <div className="search-facet-single-select-panel__title-inner">
              {displayName}
            </div>
          </div>
        </SearchLink>
        <div className="search-facet-single-select-panel__count">
          {commaStyleString(item.count)}
        </div>
      </li>
    )
  }

  // show category list if there are more than 0 item in the list
  if (items && items.length > 0) {
    return (
      <ul className={optionListClassNames}>
        {items.map((item, idx) => {
          return renderOption(item, idx)
        })}
      </ul>
    )
    // if there's no more category to show, show the ran out of categoreis section
  } else {
    const parentQuery = Object.assign({}, locationParams)
    const delimiter = get(filterParamsConfig, `${type}.delimiter`)
    const optionArray = locationParams[type].split(delimiter)
    parentQuery[type] = optionArray
      .slice(0, optionArray.length - 1)
      .join(delimiter)
    return (
      <div className="search-facet-panel__more-results">
        <p className="fds-c-text-body fds-u-mt4">
          Sorry, we ran out of options :)
        </p>
        <p className="fds-c-text-body">
          <SearchLink
            locationParams={parentQuery}
            className="fds-c-text-link -decoration-reversed"
            rel="nofollow"
          >
            Take me back to the previous option
          </SearchLink>
        </p>
      </div>
    )
  }
}

PanelBody.propTypes = {
  items: PropTypes.array.isRequired,
  locationParams: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isExpandable: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
}

export default PanelBody
